import { Chart, DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutBrokeragePlanningPerformanceProfit extends Layout {
    chartProfit: Chart;
    sourceBPPerfProfit: DataSource;
    tableBPPerfProfit: Table;
}
